import Vue from "vue";

export async function list() {
    const response = await Vue.prototype.$http.get("/units");
  
    return response.data;
  }